import React from 'react';

import ChartUnavailableNotice from 'views/playground/features/data-lab/components/charts/chart-unavailable-notice';

type Props = {
  height?: number;
};

// Heatmap is Pro-only.
const DensityHeatmap: React.FC<Props> = ({ height = 320 }) => (
  <ChartUnavailableNotice
    height={height}
    title="Density heatmap — out of scope (license restricted)"
    description="Biomass by site and week on a sequential colour scale with a piecewise legend, once an @mui/x-charts-pro licence covers Heatmap."
  />
);

export default DensityHeatmap;
